/**
 * Inserts a content block — used by both the slash command menu (inside the
 * editor) and the "Add content" button menu (outside, in the meeting frame).
 * Single source of truth so both surfaces behave identically.
 *
 * Takes an `insertMarkdown` callback rather than an editor ref so callers can
 * source it however they like (MDXEditor publishers from inside the editor, or
 * `editorRef.current.insertMarkdown` from outside).
 */

import { MutableRefObject } from 'react'
import { ContentBlockType } from './contentBlocks'

export interface ContentBlockInsertionDeps {
   insertMarkdown: (markdown: string) => void
   openImageUploadRef?: MutableRefObject<(() => void) | null>
   openMindsetUploadRef?: MutableRefObject<(() => void) | null>
   openFileUploadRef?: MutableRefObject<(() => void) | null>
}

export function insertContentBlock(type: ContentBlockType, deps: ContentBlockInsertionDeps): void {
   switch (type) {
      case 'delivery-note':
         deps.insertMarkdown(`:::GapDeliveryNote
Delivery note
:::`)
         return
      case 'todo':
         deps.insertMarkdown(`- [ ] Task 1
- [ ] Task 2
- [ ] Task 3`)
         return
      case 'image':
         deps.openImageUploadRef?.current?.()
         return
      case 'mindset':
         deps.openMindsetUploadRef?.current?.()
         return
      case 'date': {
         const oneMonthFromNow = new Date()
         oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1)
         deps.insertMarkdown(`:GapTime{timestamp="${oneMonthFromNow.getTime()}" includeTime="true"}`)
         return
      }
      case 'file-attachment':
         deps.openFileUploadRef?.current?.()
         return
      case 'table':
         deps.insertMarkdown(`| Column 1 | Column 2 |
| --- | --- |
| Cell 1 | Cell 2 |
| Cell 3 | Cell 4 |`)
         return
   }
}
